const themeTypography = {
  fontFamily: 'Muli, Arial, sans-serif',
  fontSize: 14,
  htmlFontSize: 14,
  body1: {
    fontSize: 12,
  },
}
export default themeTypography
